export default __webpack_public_path__ + "static/media/bg-mb.7e73f3c5.webp";